import _get from "lodash/get";
import {getArticleAnchorId, getArticlePrTrackingUrl} from "../selectors/articles";
import {get} from "../../util/service";
import { scroller } from "react-scroll";


/**
 * Redux Action (thunk) that invokes the tracking service for an article
 * @param {string} accessToken
 * @returns {Function}
 */
export const trackArticle = (id) => (dispatch, getState) => {
    const state = getState();
    const trackingUrl = getArticlePrTrackingUrl(state, id);
    if(trackingUrl){
        dispatch({
            type: "articles/PR_TRACKING_INIT",
            payload: {
                id
            }
        });
        get(trackingUrl, {
            redirect: "manual"
        }).then((response) => {
            dispatch({
                type: "articles/PR_TRACKING_URL_SUCCESS",
                payload: _get(response, "newsletters", []),
            });
        }).catch((error) => {
            dispatch({
                type: "articles/PR_TRACKING_URL_ERROR",
                payload: error
            });
        });
    }
};

/**
 * Run the initial article scroll
 * @param id
 * @returns {Function}
 */
export const initialArticleScroll = (id) => (dispatch, getState) => {
    const state = getState();
    const anchorHash = getArticleAnchorId(state, id);
    
    setTimeout(() => {
        scroller.scrollTo(anchorHash, { smooth: true });
    }, 100)

    dispatch({
        type: "articles/PR_FIRST_SCROLL",
        payload: {
            hash: anchorHash
        }
    });
};
